import React from 'react';
import { motion } from 'framer-motion';
interface BackgroundPatternProps {
  className?: string;
}
export function BackgroundPattern({
  className = ''
}: BackgroundPatternProps) {
  return <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`} data-id="element-68">
      <motion.div className="absolute inset-0 opacity-30" initial={{
      opacity: 0
    }} animate={{
      opacity: 0.3
    }} transition={{
      duration: 1.5
    }} data-id="element-69">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" className="absolute inset-0" data-id="element-70">
          <defs data-id="element-71">
            <pattern id="grid-pattern" width="40" height="40" patternUnits="userSpaceOnUse" data-id="element-72">
              <circle cx="1" cy="1" r="1" fill="currentColor" data-id="element-73" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid-pattern)" data-id="element-74" />
        </svg>
      </motion.div>
    </div>;
}